import { ClubBookingApiClient } from "../../common/api/ClubBookingApiClient";
import { TodayShift } from "../../model/members/ShiftChecklist";

// Staff-facing Staff Daily endpoints (gated CanManageFollowUps; per-user writes resolve
// the caller's staff_user by email). Template CRUD lives on ClientConfigService instead.
//
// There is no sign-off call: the feedback dropped that step — ticking the items off is the
// whole interaction.
export class ShiftChecklistService extends ClubBookingApiClient {
  /** Today's shift blocks with per-item completion (optionally for a given date). */
  async getToday(date?: string): Promise<TodayShift[]> {
    const params = date ? { date } : undefined;
    const raw = await this.get<TodayShift[]>("/dashboard/shifts/today", params);
    return Array.isArray(raw) ? raw : [];
  }

  /**
   * Ticks (done=true) or unticks (done=false) a checklist item. `date` is the operator's
   * local date (YYYY-MM-DD) so the row lands on the day they see, not the UTC day.
   */
  async setItemCompletion(itemId: number, done: boolean, date?: string): Promise<void> {
    const q = date ? `?date=${encodeURIComponent(date)}` : "";
    await this.put(`/dashboard/shifts/items/${itemId}/completion${q}`, { done });
  }
}
